// built-from: /facilitation-experience-binding v1 impl:facilitation-experience-binding role:implementation
import { useEffect, useState } from 'react';
import type { FacilitationBinding } from './outcomeChannel';

export interface FacilitationExperience {
  binding: FacilitationBinding;
  surface: { id: string; title?: string; workspaceLabel?: string };
  completionCapabilityId?: string;
}

export function useFacilitationExperience(sessionId: string) {
  const [experience, setExperience] = useState<FacilitationExperience | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    const legacyExperience = typeof window !== 'undefined'
      ? new URLSearchParams(window.location.search).get('legacyExperience')
      : null;
    const query = legacyExperience === 'vision' ? '?legacyExperience=vision' : '';
    fetch(`/api/facilitation/${encodeURIComponent(sessionId)}/experience${query}`)
      .then(async (response) => {
        const body = await response.json().catch(() => null) as FacilitationExperience & { error?: string };
        if (!response.ok) throw new Error(body?.error || 'This facilitation method is unavailable.');
        return body;
      })
      .then((body) => {
        if (!cancelled) setExperience(body);
      })
      .catch((cause) => {
        if (!cancelled) setError(cause instanceof Error ? cause.message : 'This facilitation method is unavailable.');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [sessionId]);

  return { experience, error, loading };
}
